import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";
import { calcRem } from "styles/theme";
import { StatusValue } from "components/blocks/status/Status";
import { FIRMWARE_UPDATE_STEP } from "api/interfaces/settingsInterface.interface";

export const Row = styled.div<{ $inline?: boolean; onClick?: () => void }>`
  ${FLEX.FlexStartCenter};
  gap: 7px;
  ${({ $inline }) =>
    $inline &&
    `
    display: inline-flex;
  `}
  ${({ onClick, theme }) =>
    `
    .firmware-icon {
      color: ${onClick ? theme.COLORS.SELECTED : "inherit"};
      * {
        stroke: ${onClick ? theme.COLORS.SELECTED : "inherit"} !important;
      }
    }
  `}
  ${({ onClick }) =>
    onClick &&
    `
    cursor: pointer;
  `}
`;
export const WebAppRow = styled.div`
  ${FLEX.FlexStartCenter};
  margin: -18px 0;
  padding: 18px 0;
  cursor: default;
`;
export const NameLabel = styled(Row)`
  /* gap: 7px; */
  cursor: pointer;
  padding-bottom: 3px;
`;

export const ButtonWrapper = styled(Row)<{ disabled?: boolean }>`
  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.25;
  `}
`;

export const RowLink = styled.span<{ disabled?: boolean }>`
  ${FLEX.FlexCenterCenter};
  gap: 1px;
  padding: 15px 4px;
  margin: -15px 0;
  color: ${({ color, theme, disabled }) =>
    disabled
      ? COLORS.GRAY
      : color
      ? color
      : theme.value === "light"
      ? COLORS.COMPANY
      : COLORS.SELECTED};
  ${({ disabled }) =>
    !disabled &&
    `
    cursor: pointer;
    text-decoration: underline;
  `}
  font-size: ${calcRem(14)};
`;

export const DeleteButtonWrapper = styled.div`
  @media (max-width: 1400px) {
    button {
      min-width: 0;
    }
  }
  @media (max-width: 1200px) {
    display: none;
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  padding: 17px 0 4px;
`;
export const TitleWrapper = styled.div`
  ${FLEX.FlexBetweenCenter};
  width: 100%;
`;

export const Label = styled.label`
  ${FLEX.FlexStartCenter};
  align-items: flex-end;
  gap: 4px;
  font-size: ${calcRem(14)};
  margin-left: 10px;
  color: ${({ theme }) => theme.COLORS.WHITE};
  span {
    text-decoration-color: ${({ theme }) => theme.COLORS.WHITE};
  }
  ${({ onClick, theme }) =>
    onClick &&
    `
    cursor: pointer;
    color: ${theme.COLORS.SELECTED};
    span {
      text-decoration: underline;
      text-decoration-color: ${theme.COLORS.SELECTED};
    }
  `}
  > img {
    height: 15px;
  }
`;

export const SubTitleWrapper = styled.div`
  ${FLEX.FlexStartEnd};
  gap: 7px;
  width: 100%;

  #selected-merged-name {
    max-width: 140px;
  }
  /* ${mediaQuery.isMobile} { */
  > div {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  /* } */
`;

export const LicenseInfo = styled.ul`
  ${FLEX.FlexStartEnd};
  gap: 24px;

  .trial-type {
    font-weight: 500;
    color: ${COLORS.BUTTONS2};
    margin-bottom: 1px;
  }

  button {
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
`;

export const LicenseInfoItem = styled.li<{ isLicense?: boolean }>`
  color: ${({ theme }) => theme.COLORS.WHITE};

  .license-title {
    display: inline;
  }

  ${({ isLicense, theme }) =>
    isLicense &&
    `
    text-decoration: underline;
    text-decoration-color: ${theme.COLORS.STATUS};
    cursor: pointer
  `}
`;

export const SubscriptionInfoStyled = {
  Wrapper: styled.div`
    ${FLEX.FlexEndEnd};
    flex-direction: column;
    gap: 3px;

    .title {
      font-size: ${calcRem(10)};
      color: ${({ color, theme }) => (color ? color : theme.COLORS.BUTTONS2)};
    }
  `,
  Value: styled(StatusValue)`
    font-size: ${calcRem(16)};
    ${FLEX.FlexEndEnd};
    flex-direction: column;
    gap: 4px;

    .expire-text {
      font-size: ${calcRem(12)};
      color: ${({ theme }) => theme.COLORS.TEXT};
    }
  `,
  Date: styled(StatusValue)`
    font-size: ${calcRem(16)};
    font-weight: normal;
    color: ${({ color, theme }) => (color ? color : theme.COLORS.STATUS)};
  `,
};

export const UpdateFirmwareStyled = {
  Wrapper: styled.div<{ status?: FIRMWARE_UPDATE_STEP }>`
    width: 100%;
    max-width: 510px;
    margin: 0 auto;
    color: ${({ theme }) => theme.COLORS.WHITE};
    .ant-progress {
      .ant-progress-inner {
        border-radius: 2px;
        background-color: ${({ theme }) => theme.COLORS.WHITE}10;
      }
      .ant-progress-bg {
        background-color: ${({ theme, status }) =>
          status === FIRMWARE_UPDATE_STEP.FAILED
            ? theme.COLORS.RED
            : COLORS.BUTTONS2};
        border-radius: 2px;
        font-size: ${calcRem(12)};
      }
    }
  `,
  ConfirmModal: styled.div`
    ${FLEX.FlexCenterCenter};
    flex-direction: column;
    gap: 10px;
    p {
      color: ${({ theme }) => theme.COLORS.WHITE};
      font-size: ${calcRem(17)};
      font-weight: 500;
    }
    b {
      color: ${COLORS.COMPANY};
    }
  `,
  UpdateDescription: styled.div`
    font-size: ${calcRem(14)};
    color: ${({ theme }) => theme.COLORS.WHITE}80;
    line-height: 1.5;
    padding: 20px 0 0;
  `,
  Reason: styled.div`
    position: relative;
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 8px;
    padding: 20px 0 0 50px;
    h3 {
      font-size: ${calcRem(16)};
      font-weight: 500;
    }
    p {
      opacity: 0.6;
      font-size: ${calcRem(14)};
    }
    .alert-icon {
      position: absolute;
      top: 20px;
      left: 0;
      color: ${COLORS.VALIDATERED};
    }
  `,
  Buttons: styled.div`
    ${FLEX.FlexCenterCenter};
    gap: 10px;
    padding-top: 40px;
  `,
  FailedIcon: styled.div`
    position: relative;
    .failed-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-left: -3px;
      margin-top: -3px;
    }
  `,
  Settings: styled.div`
    ${FLEX.FlexEndEnd};
    width: 100%;
    text-align: right;
    padding-bottom: 10px;
    span {
      font-size: ${calcRem(14)};
      color: ${({ theme }) => theme.COLORS.SELECTED};
      text-decoration: underline;
      cursor: pointer;
    }
  `,
  UpdateStatus: styled.div`
    font-size: ${calcRem(16)};
    font-weight: 500;
    width: 100%;
    padding: 20px 0 10px;
  `,
  InfoWrapper: styled.div`
    ${FLEX.FlexBetweenEnd};
    gap: 4px;
    width: 100%;
    padding: 20px 0 0;
    .bg-path {
      fill: ${({ theme }) => theme.COLORS.SIDEBARBG} !important;
    }
    .close-path {
      fill: ${({ theme }) => theme.COLORS.VALIDATERED} !important;
    }
  `,
  RecorderInfo: {
    Wrapper: styled.div`
      ${FLEX.FlexBetweenCenter};
      gap: 4px;
      width: 100%;
      padding: 12px;
      border: 1px solid ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
      border-radius: 3px;
      color: ${({ theme }) => theme.COLORS.WHITE};
      font-size: ${calcRem(14)};
    `,
    Label: styled.div`
      ${FLEX.FlexStartCenter};
      gap: 8px;
    `,
    Cameras: styled.div``,
  },
  Container: styled.div`
    ${({ theme }) => theme.COLORS.WHITE};
  `,
  Text: styled.div`
    ${FLEX.FlexCenterCenter};
    font-size: ${calcRem(16)};
    flex-direction: column;
    font-weight: 500;
    width: 100%;
    padding: 10px 0 25px;
    .scheduled-time {
      padding-top: 10px;
      font-size: ${calcRem(14)};
      color: ${({ theme }) => theme.COLORS.SELECTED};
      font-weight: 400;
    }
  `,
  Version: {
    Wrapper: styled.div`
      ${FLEX.FlexBetweenEnd};
      gap: 4px;
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
      padding: 20px 0;
      width: 100%;
    `,
    Label: styled.div<{ status: FIRMWARE_UPDATE_STEP }>`
      font-size: ${calcRem(14)};
      ${FLEX.FlexStartStart};
      flex-direction: column;
      gap: 4px;
      color: ${({ status, theme }) =>
        status === FIRMWARE_UPDATE_STEP.FAILED
          ? theme.COLORS.RED
          : status === FIRMWARE_UPDATE_STEP.SUCCESS
          ? theme.COLORS.GREEN
          : theme.COLORS.WHITE};
      b {
        font-size: ${calcRem(20)};
        ${({ status }) =>
          (status === FIRMWARE_UPDATE_STEP.FAILED ||
            status === FIRMWARE_UPDATE_STEP.SUCCESS) &&
          `
          font-weight: 500;
          `}
      }
    `,
    ReleaseNote: styled.div`
      font-size: ${calcRem(14)};
      color: ${({ theme }) => theme.COLORS.SELECTED};
      text-decoration: underline;
      cursor: pointer;
    `,
  },
};
